<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        탐지
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">탐지</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              탐지 상세 정보
            </div>
            <div class="mb7">
              <small v-if="!add && model.detected_at">시작 시간 : ({{model.detected_at | datetime}})</small>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <!-- <b-col md="4">
              <b-form-group>
                <label for="ph_version" v-b-tooltip.hover>Version</label><br>
                <label for="ph_version">{{model.ver}}</label>
              </b-form-group>
            </b-col> -->
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_task_key">task_key</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <label for="ph_task_key">{{model.task_key}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover>이름</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <label for="ph_domain">{{model.name || 'None'}}</label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_domain" v-b-tooltip.hover>도메인</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label for="ph_domain">{{model.domain}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_count" v-b-tooltip.hover>위험수준</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <!-- <label for="ph_page" v-if="model && model.level">{{codes.WMDS_TYPE[model.level]}} 위험 수준</label> -->
              <b-badge v-if="model && model.level && model.level == 'H'" variant= "danger">위험</b-badge>
              <b-badge v-else-if="model && model.level && model.level == 'W'" variant= "warning">경고</b-badge>
              <b-badge v-else-if="model && model.level && model.level == 'N'" variant= "info">조심</b-badge>
              <b-badge v-else variant= "secondary">의심</b-badge>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_count" v-b-tooltip.hover>타입</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
               <label for="ph_ext" v-if="model && model.type">{{codes.WMDS_TYPE[model.type]}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_count" v-b-tooltip.hover>탐지 깊이</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <label for="ph_detect" v-if="model && model.detail_data">{{JSON.parse(model.detail_data).depth}} 깊이</label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_count" v-b-tooltip.hover>HASH</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label for="ph_ext" v-if="model && model.detail_data">{{JSON.parse(model.detail_data).url_hash}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_count" v-b-tooltip.hover>MD5</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <label for="ph_ext" v-if="model && model.detail_data">{{JSON.parse(model.detail_data).md5}}</label>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_count" v-b-tooltip.hover>코드 확인</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <label for="ph_detect" v-if="model.detail_data && (JSON.parse(model.detail_data).f1code || JSON.parse(model.detail_data).ucode)">{{JSON.parse(model.detail_data).f1code || JSON.parse(model.detail_data).ucode}}</label>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="image">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_count" v-b-tooltip.hover>캡쳐본</label><br>
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              <a @click="toggle_thumbnail" ><img :src="image" :style="{ width: thumbnail_size }"></a>
            </b-col>
          </b-row>
          <!-- <template>
              <b-button size="sm" variant="danger" @click="confirm = true"> 삭제 </b-button>
          </template> -->
          <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              탐지 경로
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <pre slot="body" style="max-width: 100%; max-height: 500px; overflow:auto;">
                <!-- <div v-for="(item, index) in page_list" :key="index" :style="{ 'padding-left' : index * 10 + 'px'}">{{item}} -->
                <div v-for="(item, index) in url_tree" :key="index">{{item}}
                </div>
              </pre>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
           <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              HTML 데이터
            </div>
          </div>
          <hr>
          <b-row>
            <b-col md="12">
              <!-- <pre style="max-height: 500px; max-width: 100%; overflow:auto;">{{model}}</pre> -->
              <!-- <pre style="max-height: 500px; max-width: 100%; overflow:auto;">{{model.detail_data}}</pre> -->
              <div style="max-height: 500px; overflow: auto;">
                <pre slot="body" style="width: 3000px; overflow: visible;" v-if="model && model.detail_data">{{JSON.parse(model.detail_data).data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Content Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      삭제하시겠습니까?
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>